// extracted by mini-css-extract-plugin
export var list = "activities-module--list--IgZ0h";
export var publicRelationsDivision = "activities-module--public-relations-division--+1YGJ";